const getInstanceLoadErrorMessage = ({ error, instance, loading }) => {
  if (error) {
    return `Error loading instance: ${error.message || "An unexpected error occurred"}`;
  }

  if (!loading && !instance) {
    return "Instance not found.";
  }

  return null;
};

export { getInstanceLoadErrorMessage };
